//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  components: {// indexTabPermission: () => import('./components/permission'),
    // indexTabEditor: () => import('./components/editor'),
    // indexTabPosition: () => import('./components/position')
  },
  data: function data() {
    return {
      active: 'position',
      h4title: this.$t('Income statistics')
    };
  }
};